import {Autocomplete, Chip, TextField} from "@mui/material";
import React from "react";


export interface IChipsFieldProps<T> {
	readonly onValueChange?: (values: string[] | null) => void;
	readonly optionValue: (option: T|string) => string;
	readonly optionLabel: (option: T|string) => string;
	label: string;
	endAdornment?: React.ReactNode;
	options: T[];
	defaultValues?: string[];
	value?: string[];
	readonly onValidate?: (value: string) => string;
	groupBy?: (option: T) => string;
}

export function ChipsField<T>(props:  IChipsFieldProps<T>) {

	//const [value, setValue] = useState<string[]>(props.defaultValues??[]);
	return	<Autocomplete
		multiple
		groupBy={props.groupBy}
		onChange={(event,value) => {
			props.onValueChange && props.onValueChange([...new Set(value.map((v) => props.optionValue(v)))]);
		}}
		value={props.value}
		options={props.options}
		getOptionLabel={(option) => typeof option === "string" ? option : props.optionLabel(option)}
		freeSolo={true}
		renderTags={(value, getTagProps) =>
			value.map((option, index) => (
				<Chip variant="outlined" label={typeof option === "string" ? option : props.optionValue(option)} {...getTagProps({ index })} />
			))
		}
		autoSelect
		renderInput={(params) => (
			<TextField
				{...params}
				InputProps={{
					...params.InputProps,
					endAdornment: props.endAdornment
				}}
				label={props.label}
			/>
		)}
	/>;

}
